<template>
  <div class="editor scroll-vertical">
    <div class="form-section">
      <form-field icon="name" title="Profile Name">
        <input v-model="internalProfile.name"
            class="input"
            type="text"
            placeholder="Name">
      </form-field>
      <form-field icon="description" title="Description">
        <textarea
          v-model="internalProfile.description"
          class="textarea"
          type="text"
          placeholder="Description"></textarea>
      </form-field>
    </div>

    <div class="form-section">
      <fieldset class="fieldset">
        <legend>Action Configuration</legend>
        <form-field icon="action" title="Action Configuration">
          <multiselect
            v-model="actionConfigs"
            :options="actionConfigsOptions"
            :searchable="false"
            :close-on-select="true"
            :show-labels="false"
            label="name"
            track-by="id"
            placeholder="Pick an Action Config">
          </multiselect>
        </form-field>
      </fieldset>
    </div>

    <div class="form-section">
      <fieldset class="fieldset">
        <legend>Auto Update Options</legend>
          <div class="field">
            <b-checkbox v-model="internalProfile.autoUpdate">
              Enable AutoUpdate
            </b-checkbox>
          </div>
      </fieldset>
    </div>

    <div class="form-section">
      <fieldset class="fieldset">
        <legend>Endpoint Information Collection</legend>
        <div class="field level">
          <div class="level-left">
            <span class="level-item label">Asset Checkin Information:</span>
            <b-checkbox
              v-for="attr in endpointAttrs"
              :key="attr.label"
              v-model="attr.selected"
              class="level-item">
              {{ attr.label }}
            </b-checkbox>
          </div>
        </div>
        <form-field icon="circle" title="Sync Interval (seconds)">
          <input v-model.number="internalProfile.infoSync.infoSyncInterval"
            class="input sync-interval"
            type="number">
        </form-field>
      </fieldset>
    </div>
    <div class="form-section">
      <fieldset class="fieldset">
        <legend>Insights</legend>
        <div class="field level">
          <div class="level-left">
            <b-checkbox
              v-model="collectInsights"
              class="level-item">
              Enable Insights Collection
            </b-checkbox>
          </div>
        </div>
        <form-field
          icon="circle" title="Insights Collection Interval (seconds)" :enabled="collectInsights">
          <input v-model.number="internalProfile.infoSync.insightsSyncInterval"
            class="input"
            type="number"
            :disabled="!collectInsights">
        </form-field>
      </fieldset>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import FormField from '@/components/forms/FormField.vue';

export default {
  name: 'ProfileEditCreate',
  components: {
    Multiselect,
    FormField,
  },
  props: {
    profile: {
      type: Object,
      required: true,
    },
  },
  async mounted() {
    const actionConfigs = await this.$store.dispatch('primary/listActionConfigs', {
      direction: 'DESC',
      field: 'created',
    });
    this.actionConfigsOptions = actionConfigs.items;
    this.updateCurrentAttrs();
  },
  watch: {
    internalProfile() {
      this.$emit('update:profile', this.internalProfile);
    },
    actionConfigs() {
      this.internalProfile.actionConfigs = this.actionConfigs.id;
    },
    endpointAttrs: {
      deep: true,
      handler() {
        this.updateCurrentAttrs();
      },
    },
    collectInsights() {
      this.updateCurrentAttrs();
    },
  },
  data() {
    return {
      endpointAttrs: this.$typeDefs.endpoint,
      internalProfile: this.profile,
      actionConfigsOptions: [],
      actionConfigs: this.profile.actionConfigs,
      collectInsights: this.profile.infoSync.attrs.includes('insights'),
    };
  },
  methods: {
    updateCurrentAttrs() {
      let attrs = [];

      // First check if insights collection is enabled
      if (this.collectInsights) {
        attrs.push('insights');
      }

      this.endpointAttrs.forEach((a) => {
        if (a.selected) {
          if (typeof a.value === 'string') {
            attrs.push(a.value);
          } else if (Array.isArray(a.value)) {
            attrs = attrs.concat(a.value);
          }
        }
      });
      this.internalProfile.infoSync.attrs = attrs;
    },
  },
};
</script>
